exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rating--ZWsOA{margin-top:20px;padding:7px;border-radius:4px}.text--Hb_xX{display:flex;flex-direction:row;justify-content:flex-end;width:100%;align-items:center;margin:0;font-style:italic;min-height:35px}@media(max-width:480px){.text--Hb_xX{flex-direction:column;gap:16px}}.icons--2KiUi{transform:translateY(-3px);margin-left:20px;width:60px;display:inline-flex;justify-content:space-between;align-items:center;font-size:20px}@media(max-width:480px){.icons--2KiUi{width:100px;margin-left:0}}.icons--2KiUi i{color:#b2b2b2;cursor:pointer}.icons--2KiUi .selected--2KB01{color:#4c4c4c}.down--1I9xz{transform:translateY(3px)}.loader--3r-V6{transform:translateY(-2px);position:static;margin-left:20px;width:60px;height:auto}", ""]);

// Exports
exports.locals = {
	"rating": "rating--ZWsOA",
	"text": "text--Hb_xX",
	"icons": "icons--2KiUi",
	"selected": "selected--2KB01",
	"down": "down--1I9xz",
	"loader": "loader--3r-V6"
};